export default __webpack_public_path__ + "static/media/caso_3_2.245c7025.jpg";